<template>
  <v-container
    id="comercial-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <dashboard-filtro-mais-vida
          :primeiro="enablePrimeiroDia"
          :ultimo="enableUltimoDia"
          :empresas="enableEmpresa"
          :url="link"
          :cidades="enableCidades"
          :vendedores="enableVendedores"
          :redes="enableRedes"
          :areas="enableAreas"
          :btn1="enableBtn"
          :btn2="disableBtn"
          :enable-datas="enableDatas"
          :produto-multiplo="enableProdutoMultiplo"
          :tipo-brinde="enableTipoBrinde"
          :motivo-brinde="enableMotivoBrinde"
          :receitas="enableReceita"
          :segmentos="enableSegmentos"
        />
        <v-container>
          <v-row
            v-if="enableBtnPrint"
            id="btnPrint"
          >
            <v-btn
              class="col-4 col-sm-3 col-md-1 col-lg-1"
              small
              :color="corPrimaria"
              dark
              :loading="imprimindo"
              @click="imprimir()"
            >
              <v-icon>
                mdi-printer
              </v-icon>
              Imprimir
              <template v-slot:loader>
                <span>Imprimindo...</span>
              </template>
            </v-btn>
          </v-row>
        </v-container><br>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <dashboard-brinde />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import eventEmit from '../../components/core/EventoEmit'
  import html2canvas from 'html2canvas'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'DashboardFormBrind',
    emits: ['updateBrinde', 'disableConsulta', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltroMaisVida: () => import('../../components/core/FiltrosMaisVida'),
      DashboardBrinde: () => import('../../graficos/Brinde/Brinde'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      usuarioIdentificado: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      metaMensal: 0,
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      dateFormatted: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      link: window.location.href,
      empresa: [],
      cidades: [],
      areas: [],
      vendedores: [],
      receita: [],
      tipoBrinde: [],
      motivoBrinde: [],
      segmentos: [],
      paginaEnable: true,
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableClientes: false,
      enableCidades: true,
      enableAreas: true,
      enableVendedores: true,
      enableRedes: false,
      enableProdutos: false,
      enableLinhas: false,
      enableBtn: true,
      disableBtn: false,
      enableDatas: true,
      enableProdutoMultiplo: true,
      exibirFiltrosCidades: false,
      enableTipoBrinde: true,
      enableMotivoBrinde: true,
      enableReceita: true,
      enableSegmentos: true,
      orientacao: [],
      codigoIds: ['383'],
      enableBtnPrint: false,
      imprimindo: false,
      headers: [
        { text: 'Núm. da nota', value: 'nota', align: 'left', class: 'black--text title' },
        { text: 'Cliente', value: 'cliente', align: 'left', class: 'black--text title' },
        { text: 'Vendedor', value: 'vendedor', align: 'left', class: 'black--text title' },
        { text: 'Área comercial', value: 'area', align: 'left', class: 'black--text title' },
        { text: 'Valor', value: 'faturamento', align: 'center', class: 'black--text title' },
        { text: 'Motivo Brinde', value: 'motivoBrinde', align: 'left', class: 'black--text title' },
      ],
      dadosBridne: [],
    }),

    created () {
      eventEmit.$on('update-dados-mais-vida', this.handleUpdateDados)

      eventEmit.$on('set-dados-print-brinde', this.handleDadosBrinde)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados-mais-vida', this.handleUpdateDados)

      eventEmit.$off('set-dados-print-brinde', this.handleDadosBrinde)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Brindes')
      } else {
        this.$router.push('/login')
      }
    },

    methods: {
      handleUpdateDados (dataInicial, dataFinal, empresaSelect, cidadeSelect, areaSelect, redeSelect, vendedorSelect, produtoSelect, linhaSelect, clienteSelect, caixaSelect, tipoDevolucao, motivoDevolucao, primeiroDia2, date2, select1, cidadeSelect1, areaSelect1, redeSelect1, vendedorSelect1, produtoSelect1, linhaSelect1, clienteSelect1, caixaSelect1, selectReceita, segmento, segmento1, supervisorSelect, supervisorSelect1, selectTipoBrinde, selectMotivoBrinde) {
        this.dataInicial = dataInicial
        this.dataFinal = dataFinal
        this.empresa = empresaSelect
        this.cidades = cidadeSelect
        this.areas = areaSelect
        this.redes = redeSelect
        this.vendedores = vendedorSelect
        this.produtos = produtoSelect
        this.clientes = clienteSelect
        this.tipoBrinde = selectTipoBrinde
        this.motivoBrinde = selectMotivoBrinde
        this.receita = selectReceita
        this.segmento = segmento

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('dataInicial', this.dataInicial)
        localStorage.setItem('dataFinal', this.dataFinal)

        this.dadosBrinde = []

        this.updateDados()
      },

      handleDadosBrinde (dados) {
        this.enableBtnPrint = true

        this.dadosBrinde = dados
      },

      updateDados () {
        eventEmit.$emit('disable-consulta', this.orientacao)

        if (this.tipoBrinde.length > 0) {
          eventEmit.$emit('update-brinde', this.dataInicial, this.dataFinal, this.empresa, this.cidades, this.vendedores, this.areas, this.tipoBrinde, this.motivoBrinde, this.receita, this.segmento)
        } else {
          alert('Selecione pelo menos um tipo de brinde para exibir os dados')
        }
      },

      async imprimir () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.print()
          }, 2000)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        }
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')

          let posYFiltros = 10

          const inserirFiltro = async () => {
            const title = 'Filtros selecionados'

            pdf.text(title, 105, posYFiltros)

            const dataInicial = this.dataInicial.substr(8) + '/' + this.dataInicial.substr(5, 2) + '/' + this.dataInicial.substr(0, 4)

            const ultimoDia = this.dataFinal.substr(8) + '/' + this.dataFinal.substr(5, 2) + '/' + this.dataFinal.substr(0, 4)

            const datas = 'Data inicial: ' + dataInicial + ' - Data final: ' + ultimoDia

            posYFiltros += 10

            pdf.setFontSize(10)

            pdf.text(datas, 15, posYFiltros)

            posYFiltros += 10

            const adicionarFiltros = async (pdf, posYFiltros, titulo, dados) => {
              if (dados.length > 0) {
                let texto = titulo + ' '

                for (let i = 0; i < dados.length; i++) {
                  texto += dados[i] + ', '
                }

                texto = texto.slice(0, -2)

                const linhas = this.quebrarString(texto, 135)

                linhas.forEach((linha, index) => {
                  if (posYFiltros === 200) {
                    pdf.addPage()

                    posYFiltros = 10

                    pdf.text(linha, 15, posYFiltros)

                    posYFiltros += 10
                  } else {
                    pdf.text(linha, 15, posYFiltros)

                    posYFiltros += 10
                  }
                })
              }

              return posYFiltros
            }

            posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Empresa(s) Selecionada(s):', this.empresa.map(e => e.nomeExibicao))
            posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Cidade(s) Selecionada(s):', this.cidades.map(e => e.cidade))
            posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Área(s) Selecionada(s):', this.areas.map(a => a.area))
            posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Vendedor(es) Selecionado(s):', this.vendedores.map(v => v.vendedor))
            posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Receita(s) Selecionada(s):', this.receita.map(re => re.nome))
            posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Tipo(s) Brinde(s) Selecionado(s):', this.tipoBrinde.map(t => t.tipo))
            posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Motivo(s) Brinde(s) Selecionado(s):', this.motivoBrinde.map(m => m.motivo))
            posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Segmento(s) Selecionado(s):', this.segmento.map(se => se.segmento))

            if (posYFiltros > 80) {
              pdf.addPage()

              posYFiltros = 10
            }
          }

          const columnBrinde = {
            0: { cellWidth: 30 },
            1: { cellWidth: 'auto' },
            2: { cellWidth: 'auto' },
            3: { cellWidth: 'auto' },
            4: { cellWidth: 28 },
            5: { cellWidth: 'auto' },
          }

          for (var i = 0; i < this.dadosBrinde.length > 0; i++) {
            if (i === 0) {
              await inserirFiltro()
            }

            posYFiltros += 10

            const titleDados = 'TIPO OPERAÇÃO: ' + this.dadosBrinde[i].tipo_operacao

            pdf.text(titleDados, 105, posYFiltros)

            posYFiltros += 10

            const grafico = document.getElementById('myChartBrinde' + i)

            const canvasGrafico = await html2canvas(grafico)

            const imgWidthGrafico = 100

            const imgHeightGrafico = (canvasGrafico.height * imgWidthGrafico) / canvasGrafico.width

            pdf.addImage(canvasGrafico.toDataURL('image/png'), 'PNG', 105, posYFiltros, imgWidthGrafico, imgHeightGrafico)

            posYFiltros += imgHeightGrafico + 10

            const tableDadosBrinde = this.dadosBrinde[i].dadosTabela.map(item => [
              item.nota,
              item.cliente,
              item.vendedor,
              item.area,
              item.faturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              item.motivoBrinde,
            ])

            pdf.autoTable({
              head: [this.headers.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0] } }))],
              body: tableDadosBrinde.map(row => row.map((cell, index) => {
                const isFaturamentoColumn = index === 4
                return {
                  content: cell,
                  styles: {
                    fontSize: 8,
                    textColor: [0, 0, 0],
                    halign: isFaturamentoColumn ? 'right' : 'left',
                  },
                }
              })),
              startY: posYFiltros,
              styles: { fontSize: 10 },
              theme: 'grid',
              tableWidth: 'auto',
              columnStyles: columnBrinde,
            })

            if (this.dadosBrinde.length - 1 > i) {
              pdf.addPage()

              posYFiltros = 10

              await inserirFiltro()
            }
          }

          pdf.save('relatorio_brinde.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.imprimindo = false
        }
      },

      quebrarString (str, limiteCaracteresPorLinha) {
        const palavras = str.split(' ')
        let linhaAtual = ''
        const linhas = []

        palavras.forEach(palavra => {
          if ((linhaAtual + palavra).length <= limiteCaracteresPorLinha) {
            linhaAtual += palavra + ' '
          } else {
            linhas.push(linhaAtual.trim())
            linhaAtual = palavra + ' '
          }
        })

        if (linhaAtual !== '') {
          linhas.push(linhaAtual.trim())
        }

        return linhas
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {

  }

  @media screen
  and (min-width : 481px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }

  @media screen
  and (min-width: 1380px) {

  }
</style>

<style lang="sass">
  #btnRefazerCidade
    margin: 1rem 0 0 0

  #cidadeSelectBtn
    margin: 0 0 0 1rem

</style>
